import { useRoutes } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { MatxTheme } from "./components";
// ALL CONTEXTS
import { AuthProvider } from "./contexts/JWTAuthContext";
import SettingsProvider from "./contexts/SettingsContext";
// ROUTES
import routes from "./Routes/index";
// FAKE SERVER
import "../fake-db";

// In App.js
export default function App() {
  const content = useRoutes(routes);

  return (
    <SettingsProvider>
      <AuthProvider>
        <MatxTheme>
          <CssBaseline />
          {content}
          <div
            id="modal-root"
            style={{
              position: "fixed",
              zIndex: 1600,
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              pointerEvents: "none", // Important! Allows clicks to pass through
            }}
          ></div>
        </MatxTheme>
      </AuthProvider>
    </SettingsProvider>
  );
}
